import { ParentProps, Show, createEffect, createMemo } from "solid-js";
import { GroupDef, requireSelectContext } from "../SelectContext";

export function SelectItem<T extends string | any = string>(props: ParentProps<{ value: T; label?: string; }>) {
    const ctx = requireSelectContext();

    const displayValue = createMemo(() => props.label ?? props.children ?? props.value?.toString());
    const selected = createMemo(() => ctx.value() == props.value?.toString());

    createEffect(() => {
        if (props.value === ctx.value()) {
            ctx.setDefaultDisplayValue(<>{props.label ?? props.children ?? props.value?.toString() ?? ''}</>);
        }
    })

    function Item() {
        
        function onClick() {
            ctx.setValue(props.value?.toString() ?? '');
            ctx.setOpen(false);
        }

        return <li role="button" class="flexbox horizontal middle" onClick={onClick} data-selected={selected()} style={{ "user-select": "none" }}>
            <span>
                <Show when={!displayValue()}>&nbsp;</Show>
                {displayValue()}
            </span>
        </li>
    }

    if (ctx.groups().length == 0) {
        ctx.setGroups([new GroupDef('')]);
    }
    const groupDef = ctx.groups()[ctx.groups().length - 1];
    groupDef.items.push(<Item />);

    return <></>
}
